import { render, staticRenderFns } from "./ChinaASEANInfo.vue?vue&type=template&id=74005a1a&scoped=true"
import script from "./ChinaASEANInfo.vue?vue&type=script&lang=js"
export * from "./ChinaASEANInfo.vue?vue&type=script&lang=js"
import style0 from "./ChinaASEANInfo.vue?vue&type=style&index=0&id=74005a1a&prod&lang=css"
import style1 from "./ChinaASEANInfo.vue?vue&type=style&index=1&id=74005a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74005a1a",
  null
  
)

export default component.exports